window.ContentAndFormColumns = () => {
	return {
		isOnScreen: false,
	};
};
